import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentMethodSelectionComponent } from './payment-method-selection/payment-method-selection.component';
import { PaymentSummaryComponent } from './payment-summary/payment-summary.component';
import { NgbCarouselModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReadyLimitTransferComponent } from './payment-method-selection/ready-limit-transfer/ready-limit-transfer.component';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { InstallmentOptionsComponent } from './payment-summary/installment-options/installment-options.component';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzCollapseModule, NzTabsModule } from 'ng-zorro-antd';
import { FirstTabComponent } from './payment-method-selection/ready-limit-transfer/first-tab/first-tab.component';
import { SecondTabComponent } from './payment-method-selection/ready-limit-transfer/second-tab/second-tab.component';
import { InstallmentOptionsMobileComponent } from './payment-summary/installment-options-mobile/installment-options-mobile.component';
import { SharedCommonModule } from '../../../shared/shared-common.module';


@NgModule({
  declarations: [
    PaymentMethodSelectionComponent,
    PaymentSummaryComponent,
    ReadyLimitTransferComponent,
    InstallmentOptionsComponent,
    FirstTabComponent,
    SecondTabComponent,
    InstallmentOptionsMobileComponent],
  exports: [
    PaymentMethodSelectionComponent,
    PaymentSummaryComponent
  ],
  imports: [
    CommonModule,
    NgbCarouselModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatCheckboxModule,
    MatRadioModule,
    FormsModule,
    NzTabsModule,
    NzCollapseModule,
    SharedCommonModule,
    ReactiveFormsModule,
    NgbModule
  ]
})
export class PaymentSelectionModule {
}
